import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  substitutionsAndCustomizationHeading: {
    color: theme.evPalette.charcoal[800],
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '27px',
    letterSpacing: '0px',
  },
  substitutionsAndCustomizationAdditionalFormat: {
    color: theme.evPalette.charcoal[800],
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0px',
  },
  showOptions: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0px',
  },
  checkChanges: {
    padding: '0px',
    height: '40px',
    width: '40px',
    '&:hover': {
      backgroundColor: theme.evPalette.charcoal[200],
    },
  },
  radioInput: {
    padding: 0,
  },
  optionLabel: {
    display: 'flex',
    border: `1px solid ${theme.evPalette.ocean[600]}`,
    padding: '10px 16px',
    // set border for all sides except right for all options except the last one
    borderWidth: '1px 0px 1px 1px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '19.07px',
    alignItems: 'center',
    color: theme.evPalette.ocean[600],
    '&.yes': {
      borderRadius: '4px 0px 0px 4px',
    },
    '&.ask': {
      // set border for all sides for the last option
      borderWidth: '1px',
      borderRadius: '0px 4px 4px 0px',
    },
    '&.selected': {
      color: theme.evPalette.salt[100],
      backgroundColor: theme.evPalette.ocean[600],
    },
    '&.disabled': {
      borderColor: theme.evPalette.charcoal[500],
      color: theme.evPalette.charcoal[500],
    },
    '&.disabled.selected': {
      backgroundColor: theme.evPalette.charcoal[500],
      color: theme.evPalette.salt[100],
    },
  },
  optionsContainer: {
    display: 'flex',
    maxHeight: '42px',
    margin: 'auto 0px',
  },
  addonsElementsCB2: {
    display: 'flex',
    flexDirection: 'row',
    height: 'fit-content',
    gap: '16px',
  },
  addonsElementsCB: {
    display: 'flex',
    flexDirection: 'row',
    height: 'fit-content',
    alignItems: 'center',
  },
  customCoverCB: {
    display: 'flex',
    flexDirection: 'row',
    height: 'fit-content',
    alignItems: 'center',
  },
  hideOptionButton: {
    marginLeft: '28px',
    padding: '0px',
    border: '0px',
    '&:hover': {
      backgroundColor: 'transparent',
      border: '0px',
    },
  },
}));
